import { apiAuth } from "./base";

export function getAllPromos(params) {
  let api = apiAuth();
  return api.get('v1/promos', { params });
}
